import formatTableJson from '@manage/config/tableComponentParams.js'

export default formatTableJson([
  {
    filed: 'brand',
    label: '品牌'
  },
  {
    filed: 'classify',
    label: '分类'
  },
  {
    filed: 'origin',
    label: '产地'
  },
  {
    filed: 'capacity',
    label: '容量'
  },
  {
    filed: 'type',
    label: '类型'
  },
  {
    filed: 'room',
    label: '酒柜类型',
    formatFn: function (_, row) {
      let dic = {
        1: '单间室',
        2: '双间室'
      }
      return dic[row.room] ? dic[row.room] : '--'
    }
  },
  {
    filed: 'address',
    label: '储存位置',
    formatFn: function (_, row) {
      if (!row.row || !row.col) {
        return '--'
      }
      return row.row + '行' + row.col + '列'
    }
  },
  {
    filed: 'storageTemp',
    label: '推荐设置温度(℃)'
  },
  {
    filed: 'applyTimes',
    label: '应用次数'
  }
])
